module.exports = __webpack_public_path__ + "img/29.8744382d.png";